import styled from 'styled-components';

export const StyledNavMenu = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
`;
export const StyledNavMenuItem = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
`;
export const StyledNavMenuItemCur = styled.div`
  position: relative;
  cursor: pointer;
`;
